import React from 'react';

const Icon = props => {
  const { type } = props;
  const itemType = typeof type === 'string' ? type.toLowerCase() : '';
  let iconHtml;
  switch (itemType) {
    case 'toiplus':
      iconHtml = <i className="icon toiplus" />;
      break;
    case 'photostory':
      iconHtml = <i className="icon photos" />;
      break;
    case 'video':
      iconHtml = <i className="icon videos" />;
      break;
    default:
      iconHtml = null;
  }

  return iconHtml;
};

export default Icon;
